module.exports = __webpack_public_path__ + "static/media/Recoleta-Regular.6be06780.ttf";